import React from 'react';
import type { CaseStudy } from '../data/caseStudies';
type CaseStudyArticleProps = {
  study: CaseStudy;
};
export function CaseStudyArticle({
  study
}: CaseStudyArticleProps) {
  return <article id={study.id} className="scroll-mt-28 border-t border-line py-14 first:border-t-0 first:pt-0 md:py-20" data-id="element-37" data-mp="1c1ibadkx6707">
      <p className="text-[15px] text-muted" data-id="element-38" data-mp="1g4oe1b8tpg1x">{study.lead}</p>
      <h3 className="mt-3 max-w-[720px] font-display text-[30px] font-semibold leading-[1.08] tracking-[-0.035em] text-ink md:text-[40px]" data-id="element-39" data-mp="1l2pwpv2c7dcv">
        {study.title}
      </h3>
      {study.client && <p className="mt-4 text-[16px] font-medium text-ink" data-id="element-40" data-mp="1pzgagbqo5wv4">{study.client}</p>}

      <figure className="mt-8 overflow-hidden rounded-[12px] bg-canvas shadow-[0_0_0_1px_rgba(70,28,64,0.06)]" data-id="element-41" data-mp="1utb3i5s5zo6v">
        <img src={study.image} alt={study.imageAlt} loading="lazy" className="aspect-[16/9] w-full object-cover" data-id="element-42" data-mp="1ztozgpghr7oj" />
      </figure>

      <div className="mt-6 max-w-[720px] space-y-4 text-[17px] leading-relaxed text-ink/75" data-id="element-43" data-mp="28s0zfi38zhtn">
        {study.intro.map(p => <p key={p} data-id="element-44" data-mp="2i6hbee053o65">{p}</p>)}
      </div>

      {study.steps.length > 0 && <div className="mt-12 grid gap-12 lg:grid-cols-[minmax(0,1fr)_300px] lg:gap-16" data-id="element-45" data-mp="2e3kucrq9004b">
          <ol className="space-y-8" data-id="element-46" data-mp="2947yxilb9kq4">
            {study.steps.map(step => <li key={step.heading} className="grid gap-2 md:grid-cols-[170px_minmax(0,1fr)] md:gap-8" data-id="element-47" data-mp="245n0nopmdb4b">
                <h4 className="text-[16px] font-medium text-ink" data-id="element-48" data-mp="31t5g1idsdbha">{step.heading}</h4>
                <p className="text-[16px] leading-relaxed text-ink/70" data-id="element-49" data-mp="2wuc25oul7igl">{step.text}</p>
              </li>)}
          </ol>

          <aside aria-label="Projektinformationen" className="self-start rounded-[12px] bg-canvas p-6" data-id="element-50" data-mp="2s2tz8v9077sz">
            <p className="text-[14px] font-medium text-ink" data-id="element-51" data-mp="2n3hf4i9ioeu3">Projektinformationen</p>
            <dl className="mt-4 space-y-4" data-id="element-52" data-mp="3kketg2qogke5">
              {study.info.map(row => <div key={row.label} data-id="element-53" data-mp="3ftg6wlf3iq2g">
                  <dt className="text-[13px] text-muted" data-id="element-54" data-mp="3fselpo4d8n70">{row.label}</dt>
                  <dd className="mt-1 text-[15px] leading-snug text-ink" data-id="element-55" data-mp="1dv4glivlwhm3">{row.values.join(' · ')}</dd>
                </div>)}
            </dl>
          </aside>
        </div>}

      {study.closing.heading && <div className="mt-12 flex flex-col gap-5 rounded-[12px] bg-graphite p-6 text-white md:flex-row md:items-center md:justify-between md:p-8" data-id="element-56" data-mp="1451jb6hgchhy">
          <div className="max-w-[560px]" data-id="element-57" data-mp="u7n9vqty4sz5">
            <p className="text-[19px] font-medium tracking-[-0.01em]" data-id="element-58" data-mp="u6vmh3ai61jy">{study.closing.heading}</p>
            <p className="mt-2 text-[15px] leading-relaxed text-white/60" data-id="element-59" data-mp="z7jbjjf688bj">{study.closing.text}</p>
          </div>
          <a href="/#contact" className="inline-flex shrink-0 items-center justify-center rounded-[8px] bg-white px-5 py-3 text-[15px] font-medium text-ink transition-colors duration-150 hover:bg-white/85" data-id="element-60" data-mp="l8jogg7b41hh">
            Kostenloses Angebot erhalten
          </a>
        </div>}

      {study.meta.length > 0 && <ul className="mt-6 flex flex-wrap gap-x-2 text-[14px] text-muted" data-id="element-61" data-mp="2unhyp9pv7m8h">
          {study.meta.map((m, i) => <li key={m} className="flex items-center gap-2" data-id="element-62" data-mp="2pppylsf2gtt7" data-mpi={i}>
              {i > 0 && <span aria-hidden="true" data-id="element-63" data-mp="33g33flwnvseb">·</span>}
              {m}
            </li>)}
        </ul>}
    </article>;
}